var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.44674 2.30531L1.11993 17.9545C0.499705 19.1202 1.34448 20.5266 2.66484 20.5266H19.3337C20.6547 20.5266 21.4994 19.1191 20.878 17.9534L12.5359 2.30414C11.8769 1.06788 10.1048 1.06856 9.44674 2.30531Z",
    fill: "#FBEE36",
    stroke: "#010101",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88428 6.63293V6.95482L10.4936 14.0685H11.5826L12.192 6.95482V6.63293H9.88428ZM12.0883 17.8989V15.3238H9.98799V17.8989H12.0883Z",
    fill: "#010101"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warningIcon.6dbd5fd06d88fa9dfccd9337d37014b7.svg";
export { ForwardRef as ReactComponent };